const img = require('./Colors.svg'); export default img;